<template>
  <div class="section section_no-padding section_white section_final">
    <div class="final">
      <div class="max-width">
        <div class="section__head section__head_middle">
          <h2 class="section__title">Convert More with <br>Sales-Focused Themes</h2>
          <div class="section__text">Increase revenue and raise AOV with high-performance themes—built for speed, intuitive design, and conversion-focused features.</div>
          <div class="section__buttons">
            <router-link to="/themes" class="button">
              Explore Themes
              <IconArrow />
            </router-link>
          </div>
        </div>
      </div>

      <div class="final__slider">
        <div class="scroll-banner">
          <div class="scroll-banner__track">
            <img loading="lazy" srcset="/assets/imgs/themes/megastore/final@2x.webp 2x, /assets/imgs/themes/megastore/final.webp 1x" src="/assets/imgs/themes/megastore/final@2x.webp" alt="Megastore Shopify theme final checkout and UI design" />
            <img loading="lazy" srcset="/assets/imgs/themes/megastore/final@2x.webp 2x, /assets/imgs/themes/megastore/final.webp 1x" src="/assets/imgs/themes/megastore/final@2x.webp" alt="Megastore Shopify theme final checkout and UI design" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .final {
    background:url('@/assets/imgs/final-bg.webp') no-repeat;
    background-size:cover;
    padding:var(--section-padding);
    padding-top:10.625rem;

    @include md {
      padding-top:6rem;
    }

    .section__head {
      max-width:620px;

      .section__text {
        max-width:100%;
      }
    }

    &__slider {
      img {
        filter: drop-shadow(0 0 40px rgba(127, 127, 127, 0.1));
      }

      .scroll-banner {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: auto;
        --image-width: 3211px;
        --scroll-speed:40s;
        padding:3rem 0;
        margin:-3rem 0;

        @include xs {
          --image-width: 1800px;
        }

        &__track {
          display: flex;
          width: calc(var(--image-width) * 2);
          animation: scroll-x linear infinite;
          animation-duration: var(--scroll-speed);
          gap:1.5rem;

          img {
            width: var(--image-width);
            height: auto;
            flex-shrink: 0;
            object-fit: cover;
            -webkit-user-drag: none;
            user-select: none;
            pointer-events: none;
          }
        }
      }

      @keyframes scroll-x {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(calc(-50% - 1.5rem));
        }
      }
    }
  }
</style>

<script setup>
  import IconArrow from "@/components/icons/IconArrow.vue";
</script>
